// src/lib.ts
var DATA_CY_ATTR = "data-cy";
var simple = (value) => ({
  value,
  selector: `[${DATA_CY_ATTR}='${value}']`,
  nodeProps: {
    [DATA_CY_ATTR]: value
  }
});
function complex(nodes) {
  return (value) => {
    const result = simple(value);
    Object.keys(nodes).forEach((key) => {
      const child = nodes[key];
      Object.defineProperty(result, key, {
        get: () => child(`${value}/${key}`)
      });
    });
    return result;
  };
}
function byKey(schema) {
  return (value) => {
    const result = (key) => schema(`${value}/${key}`);
    result.value = value;
    result.selector = `[${DATA_CY_ATTR}='${value}']`;
    result.nodeProps = {
      [DATA_CY_ATTR]: value
    };
    return result;
  };
}

// src/utils.ts
function getKeyFromUrl(url) {
  if (typeof url === "object" && typeof url.query === "object" && url.query !== null) {
    return url.query.category;
  }
  return url;
}
var getDataCyProps = (props) => props?.["data-cy"] ? { "data-cy": props["data-cy"] } : {};
var getTestProps = getDataCyProps;
var omitTestProps = (props) => {
  const { "data-cy": _, ...rest } = props;
  return rest;
};
var pickTestProps = (props) => {
  const { "data-cy": dataCy } = props;
  return { "data-cy": dataCy };
};
export {
  byKey,
  complex,
  getDataCyProps,
  getKeyFromUrl,
  getTestProps,
  omitTestProps,
  pickTestProps,
  simple
};
//# sourceMappingURL=index.js.map